export const TYPES_ROLES = Object.freeze({
  SUPERADMIN: "admin",
  USER: "user",
  ADMIN: "restaurant",
  BARMAN: "barman",
});
